import { createContext } from 'react';

import type { AnyPaywall } from '~/interfaces/paywall';
import type { Post as IPost, PostMetaInformation } from '~/interfaces/post';
import type { PostMergeTags } from '~/interfaces/post_merge_tags';
import type { PostTemplate } from '~/interfaces/post_template';
import type { Subscription } from '~/interfaces/subscriptions';

export interface PostDataContextType {
  post: IPost | PostTemplate;
  onlyRenderComments: boolean;
  isDraft: boolean;
  postMergeTags?: PostMergeTags;
  paywall: AnyPaywall | null;
  previewSubscription?: Subscription;
  postMetaInformation?: PostMetaInformation;
}

export const PostDataContext = createContext<PostDataContextType | undefined>(undefined);
